import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MainLayout from "../../Layout/mainLayout";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import AddImage from "../../Global Functions/addImage";
import {
  editAmenities,
  viewAmenity,
} from "../../Redux/Actions/amenitiesActions";
import { getEnums } from "../../Redux/Actions/enumsActions";
import SelectInput from "../../Global Functions/selectInput";
import TextInput from "../../Global Functions/textInput";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";

const EditSubAmenities = () => {
  const { id } = useParams();

  const dispatch = useDispatch();

  const { amenity } = useSelector((state) => state.amenities || {});

  const [amenityData, setAmenityData] = useState({
    name: "",
    position: Math.floor(Math.random() * 1000) + 1,
    amenities_for: amenity?.data?.amenities_for,
    image: "",
    id: id,
  });

  const navigate = useNavigate();

  const handleFileChange = async (event) => {
    const uploadedImage = event.target.files[0];

    if (uploadedImage) {
      const imageUrl = await AddImage(uploadedImage);
      if (imageUrl) {
        setAmenityData((prevData) => ({ ...prevData, image: imageUrl }));
      }
    }
  };

  useEffect(() => {
    dispatch(getEnums());
    dispatch(viewAmenity(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (amenity?.data) {
      setAmenityData((prevData) => ({
        ...prevData,
        ...amenity.data,
        id: id,
        position: Math.floor(Math.random() * 1000) + 1,
        amenities_for: amenity?.data?.amenities_for,
      }));
    }
  }, [amenity, id]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const nonEmptyPayload = Object.fromEntries(
        Object.entries(amenityData).filter(([_, value]) => value)
      );

      const result = await dispatch(editAmenities(nonEmptyPayload));
      if (result.statusCode === 200) {
        navigate(-1);
      }
      setAmenityData({
        name: "",
        position: Math.floor(Math.random() * 1000) + 1,
        amenities_for: "",
        image: "",
        parent: id,
      });
    } catch (error) {}
  };

  const { enumsData } = useSelector((state) => state.enumsData);

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    setAmenityData((prevData) => ({ ...prevData, [name]: value }));
  };

  return (
    <MainLayout>
      <div className="bg-white grid-span-5 border-24 padding-20" style={{ width: "100%" }}>
        <div className="flex-container flex-justify-between align-center">
          <h1>Edit Sub Amenities</h1>
          <Link to="/amenities">
            <button className="button-class">View Sub-Amenities List</button>
          </Link>
        </div>
        <div>
          <form onSubmit={handleSubmit}>
            {/* <span className="span-class">Select Amenity For</span>
            <select
              disabled
              value={amenity?.data?.amenities_for}
              onChange={(event) => {
                const value = event.target.value;
                setAmenityData((prevData) => ({
                  ...prevData,
                  amenities_for: value,
                }));
              }}
              className="input-class"
              name="amenities_for"
              id=""
            >
              <option value="">Select An Option</option>
              {enumsData?.data?.AmenityFor &&
                Object.entries(enumsData.data.AmenityFor).map(
                  ([key, value]) => (
                    <option key={key} value={value}>
                      {value.toUpperCase()}
                    </option>
                  )
                )}
            </select> */}
            <SelectInput
              disabled
              placeholder="Select an Option"
              label="Select Amenity For"
              value={amenity?.data?.amenities_for}
              onChange={(event) => {
                const value = event.target.value;
                setAmenityData((prevData) => ({
                  ...prevData,
                  amenities_for: value,
                }));
              }}
              options={
                enumsData?.data?.AmenityFor
                  ? Object.entries(enumsData.data.AmenityFor).map(
                      ([key, value]) => ({
                        label: value.toUpperCase(),
                        value: value,
                      })
                    )
                  : []
              }
            ></SelectInput>
            <div className="flex-container flex-justify-between gap-10">
              <div style={{ width: "50%" }}>
                <span htmlFor="add-image">Upload Sub-Amenity's Icon</span>
                <input
                  style={{
                    display: "none",
                  }}
                  onChange={handleFileChange}
                  type="file"
                  id="image"
                  name="image"
                />
                <label className="label-class-image" for="image">
                  Click to Upload Icon
                </label>
                <ImageShowerModalGlobal
                  file={amenityData.image}
                  keyField="image"
                  setState={setAmenityData}
                  state={amenityData}
                ></ImageShowerModalGlobal>
              </div>
              <div style={{ width: "50%" }}>
                <TextInput
                  onChange={handleAddChange}
                  className="input-class"
                  type="text"
                  label="Sub Amenity Name"
                  value={amenityData.name}
                  name="name"
                  placeholder="Enter Name"
                ></TextInput>
              </div>
            </div>
            <div className="flex-end margin-h-10">
              <Link to="/amenities">
                <button className="button-class-white">Cancel</button>
              </Link>
              <button className="button-class" type="submit">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </MainLayout>
  );
};

export default EditSubAmenities;
